<div  class="d-flex align-items-center position-relative" (click)="cancelEvent($event)">
  <div (click)="openLink($event)" class="text" [ngClass]="{ 'text--link': link || clickFunction }" matTooltip="{{ name + ' : '  + value}}">
    <span *ngIf="showName" class="text_name">{{name}}: </span>{{ value}} 
  </div>
  <i
    class="fal"
    [ngClass]="{ 'fa-copy': !copied, 'fa-check': copied }"
    [cdkCopyToClipboard]="value"
    (cdkCopyToClipboardCopied)="copy($event)"
  ></i>
</div>
